import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api";
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch Map Data by State ID
export const fetchMapData = createAsyncThunk(
  "map/fetchMapData",
  async (stateID, { rejectWithValue }) => {
    try {
      const response = await api.get(`/location/panel/Map?stateID=${stateID}`);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Update Map Data
export const updateMapData = createAsyncThunk(
  "map/updateMapData",
  async (mapData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/Map", mapData);
      alertSuccess(response.data.success);
      return response.data;
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Map Slice
const mapSlice = createSlice({
  name: "map",
  initialState: {
    mapData: null,
    status: "idle",
    error: null,
  },
  reducers: {
    clearMapError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Map Data
      .addCase(fetchMapData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMapData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.mapData = action.payload;
      })
      .addCase(fetchMapData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Update Map Data
      .addCase(updateMapData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateMapData.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Optionally update mapData here if API returns updated data
        state.mapData = action.payload.data || state.mapData;
      })
      .addCase(updateMapData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearMapError } = mapSlice.actions;

export default mapSlice.reducer;
